/**
 * Spaces Module
 *
 * Handles spaces and rooms functionality including:
 * - Export modal handling
 * - Room filter/sort functions
 * - Keyboard shortcuts for room forms
 */

import { $, ready } from '../utils/dom.js';

const ROOMS_BASE_URL = '/rooms';

// =============================================================================
// Room Filter Functions
// =============================================================================

/**
 * Apply sort filter for rooms list
 * @param {HTMLSelectElement} select - Sort select element
 */
export function applySortFilter(select) {
    const sort = select.value;
    const params = new URLSearchParams();

    if (sort) {
        params.append('sort', sort);
    }

    window.location.href = ROOMS_BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear all room filters
 */
export function clearFilters() {
    window.location.href = ROOMS_BASE_URL;
}

// =============================================================================
// Room Form Helpers
// =============================================================================

/**
 * Initialize keyboard shortcuts for room forms
 * @param {string} formId - ID of the form to submit on Ctrl+S
 */
function initKeyboardShortcuts(formId) {
    document.addEventListener('keydown', function(e) {
        // Ctrl/Cmd + S to save
        if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault();
            const form = document.getElementById(formId);
            if (form) {
                form.submit();
            }
        }
    });
}

/**
 * Initialize add first table button
 */
function initAddFirstTableButton() {
    const addFirstBtn = document.getElementById('add-first-table-btn');
    const addTableBtn = document.getElementById('add-table-btn');

    if (addFirstBtn && addTableBtn) {
        addFirstBtn.addEventListener('click', () => {
            addTableBtn.click();
        });
    }
}

// =============================================================================
// Export Modal
// =============================================================================

/**
 * Initialize export button modal handling
 */
function initExportModal() {
    const exportBtn = $('#exportButton');
    const exportModal = $('#export-modal');

    if (exportBtn && exportModal) {
        exportBtn.addEventListener('click', function() {
            // If using Bootstrap modal
            if (typeof jQuery !== 'undefined' && jQuery(exportModal).modal) {
                jQuery(exportModal).modal('hide');
            }
        });
    }
}

// =============================================================================
// Auto-Initialization
// =============================================================================

/**
 * Initialize spaces/rooms functionality
 */
function initSpaces() {
    // Initialize export modal if present
    initExportModal();

    // Initialize keyboard shortcuts for room forms
    const roomEditForm = document.getElementById('room-edit-form');
    const roomCreateForm = document.getElementById('room-create-form');

    if (roomEditForm) {
        initKeyboardShortcuts('room-edit-form');
        initAddFirstTableButton();
    }

    if (roomCreateForm) {
        initKeyboardShortcuts('room-create-form');

        // Auto-focus on room name field for new rooms
        const roomNameField = document.getElementById('room_name');
        if (roomNameField) {
            roomNameField.focus();
        }
    }
}

// Auto-initialize
ready(initSpaces);

// Expose globally for legacy onclick handlers
window.applySortFilter = applySortFilter;
window.clearFilters = clearFilters;

export default {
    applySortFilter,
    clearFilters
};
